<script lang="ts">

  import { StarType } from './StarType';

  interface Props {
    averageRatingRounded: number
  }

  let {
    averageRatingRounded,
  }: Props = $props();

  const getStarType = (index: number) => {
    const fractional = averageRatingRounded - index;

    if (fractional >= 1) {
      return StarType.FILLED;
    }
    else if (fractional >= 0.5) {
      return StarType.HALF;
    }

    return StarType.EMPTY;
  };

  let starType0 = $derived.by<StarType>(() => getStarType(0));
  let starType1 = $derived.by<StarType>(() => getStarType(1));
  let starType2 = $derived.by<StarType>(() => getStarType(2));
  let starType3 = $derived.by<StarType>(() => getStarType(3));
  let starType4 = $derived.by<StarType>(() => getStarType(4));
</script>

<div class="ft5-upselling-rating-stars">
    <oc-icon-v1 type={starType0} size="50"></oc-icon-v1>
    <oc-icon-v1 type={starType1} size="50"></oc-icon-v1>
    <oc-icon-v1 type={starType2} size="50"></oc-icon-v1>
    <oc-icon-v1 type={starType3} size="50"></oc-icon-v1>
    <oc-icon-v1 type={starType4} size="50"></oc-icon-v1>
</div>

<style lang="scss">
  .ft5-upselling-rating-stars {
    display: flex;
  }
</style>
